import API from './API';

export default class Usuario extends API {

  static lista() {
    return super.get(`/usuarios`);
  }

  static get(id) {
    return super.get(`/usuarios/${id}`);
  }

  static cadastro(dados){
    return super.post(`/usuarios`, dados);
  }

  static editar(dados,id){
    return super.put(`/usuarios/${id}`, dados);
  }

  static excluir(id){
    return super.delete(`/usuarios/${id}`);
  }

}



// WEBPACK FOOTER //
// ./src/services/api/Usuario.js